import * as base from './base';
import * as pages from './pages';
import * as typography from './typography';

export default {
  base,
  typography,
  pages,
};
